import { render, staticRenderFns } from "./rightimfo.vue?vue&type=template&id=5a9801bf&scoped=true&"
import script from "./rightimfo.vue?vue&type=script&lang=js&"
export * from "./rightimfo.vue?vue&type=script&lang=js&"
import style0 from "./rightimfo.vue?vue&type=style&index=0&id=5a9801bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9801bf",
  null
  
)

export default component.exports